import { render, staticRenderFns } from "./gridyViewer.vue?vue&type=template&id=33b0b8eb&"
import script from "./gridyViewer.vue?vue&type=script&lang=js&"
export * from "./gridyViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports